import React from "react";
import { Info } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";

export const GLOSARIO_D = {
  clase: ["Toda la clase D", "Todos los productos con stock que no han tenido ninguna venta en el periodo del estudio (normalmente 12 meses), entren cuando entren. Es la cifra más amplia."],
  muerto: ["D muerto", "Clase D cuya última entrada fue hace más de 1 año o que no tiene fecha de entrada. Por incluir los productos sin fecha suele ser algo mayor que el D real."],
  real: ["D real", "Clase D con fecha de última entrada conocida y de hace más de 1 año. Es el stock parado seguro: el que cuenta para el incentivo de stock D y la lista a recomendar."],
  anio: ["Stock con más de 1 año", "Cualquier producto con stock cuya última entrada fue hace más de 1 año, tenga ventas o no. El D real es la parte de este stock que no se ha vendido."],
};

export function InfoD({ term, className = "" }) {
  const [open, setOpen] = React.useState(false);
  const keys = term === "todos" ? ["clase", "muerto", "real"] : [term];
  const stop = (e) => { e.stopPropagation(); e.preventDefault(); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <span role="button" tabIndex={0} onClick={(e) => { stop(e); setOpen((o) => !o); }}
              className={"inline-flex items-center justify-center h-4 w-4 rounded-full text-slate-400 hover:text-slate-700 align-middle cursor-help " + className}
              aria-label="Qué significa" data-testid={`info-d-${term}`}>
          <Info size={13} />
        </span>
      </PopoverTrigger>
      <PopoverContent className="w-80 bg-white text-xs leading-relaxed space-y-2 normal-case tracking-normal font-normal" onClick={stop} data-testid={`info-d-${term}-content`}>
        {keys.map((k) => (
          <div key={k}><div className="font-bold text-slate-900 text-[13px]">{GLOSARIO_D[k][0]}</div><p className="text-slate-600">{GLOSARIO_D[k][1]}</p></div>
        ))}
        <p className="text-slate-400 text-[11px]">Todos los importes de stock van a PVP.</p>
      </PopoverContent>
    </Popover>
  );
}
